import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import { TiLocationOutline } from "react-icons/ti";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import jobBanner from "../../components/assets/careers-image.png";

const Joblist = () => {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    const sheetId = "14S-tBzPkc0p3g8fbJmoYJsPnQZ3L5i9DpV-1S69F_6A";
    const sheetName = "Sheet1"; // Change if your sheet name is different
    const url = `https://docs.google.com/spreadsheets/d/${sheetId}/gviz/tq?tqx=out:json&sheet=${sheetName}`;

    fetch(url)
      .then((res) => res.text())
      .then((text) => {
        const json = JSON.parse(text.substring(47).slice(0, -2)); // Trim the Google API response
        console.log("Raw JSON Data:", json);
        const formatted = formatGoogleSheetData(
          json?.table?.cols,
          json?.table?.rows
        );
        console.log("Formatted Data:", formatted);
        setJobs(formatted);
      });
  }, []);

  function formatGoogleSheetData(cols, rows) {
    // Step 1: Extract valid column labels
    const headers = cols.map((col) => col.label.trim());

    // Step 2: Filter out empty labels and track their indexes
    const validIndexes = headers
      .map((label, index) => (label ? { label, index } : null))
      .filter(Boolean);

    // Step 3: Map rows to objects using valid labels
    return rows.map((row) => {
      const obj = {};
      validIndexes.forEach(({ label, index }) => {
        const cell = row.c[index];
        const value = cell?.v ?? "";

        // Optional: Normalize multi-line or numbered strings into arrays
        if (
          [
            "tags",
            "responsibilities",
            "qualifications",
            "niceToHave",
            "benefitAndPerks",
            "recruitmentProcess",
            "howToApply",
            "notForYou",
          ].includes(label)
        ) {
          obj[label] = value
            .split("\n")
            .map((line) => line.replace(/^\d+\.\s*/, "").trim())
            .filter(Boolean);
        } else if (label === "postedDate" && cell.f) {
          // Use formatted date if available
          obj[label] = cell.f;
        } else {
          obj[label] = typeof value === "string" ? value.trim() : value;
        }
      });
      return obj;
    });
  }

  return (
    <div className="container">
      <div className="row pt-3">
        <div className="col-md-6">
          <h1 style={{ fontWeight: "bold" }}>
            Shape <span style={{ color: "#216fb8" }}>Your Future</span> With Us
          </h1>
          <p className="py-2">
            Join a mission-driven team that’s reshaping financial wellness by
            giving employees early access to their earnings and protecting them
            from debt traps.
          </p>
          <div className="d-flex justify-content-between">
            <input className="form-control" placeholder="Search by job title" />
            <button className="btn searchIconBtn">
              <FiSearch />
            </button>
          </div>
        </div>
        <div className="col-md-6 d-flex justify-content-end align-items-center">
          <img style={{ width: "70%" }} src={jobBanner} />
        </div>
        <div className="col-md-12 mt-4 py-5">
          <h4 className="py-2 text-muted fw-bold">Open Positions</h4>
          <div className="row">
            {jobs?.map((item, i) => {
              return (
                <div key={i} className="col-md-4 p-2">
                  <div
                    className="jobCard p-3 border rounded cursorPointer"
                    onClick={() => {
                      navigate(`/careers/${item.jobId}`, { state: item });
                    }}
                  >
                    <div className="jobTitle">{item.jobTitle}</div>
                    <div className="experienceText">{item.experience}</div>
                    <div className="d-flex">
                      {item.tags?.map((tag, j) => {
                        return (
                          <div key={j} className="careerChip me-2">
                            {tag}
                          </div>
                        );
                      })}
                    </div>
                    <div className="d-flex justify-content-between align-items-center pb-1 mt-5">
                      <div className="d-flex align-items-center text-muted">
                        <TiLocationOutline className="me-2" />
                        {item.location}
                      </div>
                      <div>
                        <MdOutlineArrowForwardIos size={20} color="#216fb8" />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Joblist;
